export default __webpack_public_path__ + "static/media/orders-active.91bd0764.svg";